import { FatInvestorsPageListInvestorsQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { MobileRow, MobileRowTitle, MobileRowValue, MobileTableRowWrap } from '@/components/table/mobileTable/mobileTable';
import { TableColumns } from '@/components/table/types';
import styled from 'styled-components';

interface InvestorMobileSumFooterProps {
  columns: TableColumns[];
  totals: FatInvestorsPageListInvestorsQuery['listInvestors']['totals'];
}

const InvestorMobileSumFooter = ({ columns, totals }: InvestorMobileSumFooterProps) => {
  return (
    <MobileSumFooterWrap>
      <MobileRow>
        <MobileRowTitle>Total</MobileRowTitle>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{columns[2].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{totals?.investmentCount}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{columns[3].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{totals?.totalValue}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>

      <MobileRow>
        <MobileRowTitle>{columns[4].title}</MobileRowTitle>
        <MobileRowValue>
          <FormattingTooltip>{totals?.totalCommitments}</FormattingTooltip>
        </MobileRowValue>
      </MobileRow>
    </MobileSumFooterWrap>
  );
};

export default InvestorMobileSumFooter;

const MobileSumFooterWrap = styled(MobileTableRowWrap)`
  background-color: ${({ theme }) => theme.layer[2]};
`;
